import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Flex, Popup } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { LogicCondition } from '@leverege/condition';
import { AttributeCondition } from '@leverege/ui-attributes';
import ConditionFilterModels from "../../../filters/filter/ConditionFilterModels.js";
import HistoryConditionEditor from "../../history/editors/HistoryConditionEditor.js";
import ConditionFilterModel from "../../../filters/filter/ConditionFilterModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.dashboard.ConditionEditor');
export default function ConditionEditor(props) {
  const {
    eventData,
    value,
    onChange,
    sharedProps
  } = props;
  const {
    objectType,
    delegate
  } = sharedProps;
  const v = useMemo(() => {
    return value && typeof value === 'object' ? {
      ...value
    } : ConditionFilterModels.getModelFor(delegate.type, `${objectType}.history`)?.create({
      rootCondition: LogicCondition.create({
        operator: 'and'
      })
    });
  }, [value, delegate?.type, objectType]);
  const [opened, setOpened] = useState(false);
  const onPopupChange = useCallback(({
    isOpened
  }) => {
    setOpened(isOpened);
  }, []);
  useEffect(() => {
    const onOpened = evt => {
      const ac = AttributeCondition.create({
        attrName: evt.detail?.attrName
      });
      const nConditionFilterModel = ConditionFilterModel?.addCondition(v, ac);
      onChange({
        data: eventData,
        value: nConditionFilterModel
      });
      setOpened(true);
    };
    window.addEventListener(`molten.filter.${objectType}.history.open`, onOpened);
    return () => {
      window.removeEventListener(`molten.filter.${objectType}.history.open`, onOpened);
    };
  }, [setOpened, v, onChange, eventData, objectType]);
  return /*#__PURE__*/_jsx(Flex, {
    variant: "rowM",
    align: "center",
    children: /*#__PURE__*/_jsx(Popup, {
      opened: opened,
      onChange: onPopupChange,
      variant: "filter",
      toggleVariant: "filter|sortFilterBar|actionBar",
      icon: tIcon('filterIcon', 'fa fa-fw fa-filter'),
      title: t('dashboardCondition'),
      children: /*#__PURE__*/_jsx(HistoryConditionEditor, {
        ...sharedProps,
        value: v,
        objectType: `${objectType}.history`,
        onChange: onChange,
        eventData: eventData
      })
    })
  });
}
ConditionEditor.TYPE = 'condition';